import * as amplitude from '@amplitude/analytics-browser';
import { Identify } from '@amplitude/analytics-browser';

import type { AnalyticsAdapter, AnalyticsAdapterInitOptions } from './analyticsAdapter';

export const createAmplitudeAdapter = (): AnalyticsAdapter => ({
  init: (apiKey: string, options: AnalyticsAdapterInitOptions): void => {
    amplitude.init(apiKey, undefined, options);
  },
  track: (eventName: string, properties?: Record<string, unknown>): void => {
    amplitude.track(eventName, properties);
  },
  setUserId: (userId: string): void => {
    amplitude.setUserId(userId);
  },
  setUserProperties: (properties: Record<string, string | number | boolean>): void => {
    const identify = new Identify();

    Object.entries(properties).forEach(([key, value]) => {
      identify.set(key, value);
    });

    amplitude.identify(identify);
  },
  unsetUserProperties: (propertyKeys: string[]): void => {
    if (propertyKeys.length === 0) {
      return;
    }

    const identify = new Identify();

    propertyKeys.forEach((key) => {
      identify.unset(key);
    });

    amplitude.identify(identify);
  },
  reset: (): void => {
    amplitude.reset();
  },
});
